// extracted by mini-css-extract-plugin
module.exports = {"declaration":"ThmPKlv4F+Rfq4ylGtkfpQ==","footer":"yemryCAlCL7kPC5LgXjIEw=="};